import { db } from '../../common/config/Firebase';
import firebase from 'firebase/app';
import moment from 'moment';

/**
 * Adds a new vacation period for an employee
 * @param {Object} vacationData - Vacation data
 * @param {string} vacationData.employeeDni - Employee DNI
 * @param {Date} vacationData.startDate - Start date of vacation
 * @param {Date} vacationData.endDate - End date of vacation
 * @param {string} vacationData.description - Vacation description
 * @returns {Promise<string>} - Created vacation ID
 */
export const addEmployeeVacationUseCase = async (vacationData) => {
    try {
        const { employeeDni, startDate, endDate, description } = vacationData;

        const docRef = await db.collection('employeeVacations').add({
            employeeDni,
            startDate: firebase.firestore.Timestamp.fromDate(moment(startDate).startOf('day').toDate()),
            endDate: firebase.firestore.Timestamp.fromDate(moment(endDate).endOf('day').toDate()),
            description: description || '',
            createdAt: firebase.firestore.Timestamp.now()
        });

        console.log('Employee vacation created with ID:', docRef.id);
        return docRef.id;
    } catch (error) {
        console.error('Error adding employee vacation:', error);
        throw error;
    }
};
